// noinspection JSUnusedGlobalSymbols
import { Environment }      from './environment.interface';
import { sharedEnvironment } from './environment.shared';

export const environment: Environment = {
  ...sharedEnvironment,
  production:     true,
  siteUrl:        'https://portal.redacaonota1000.com.br',
  reactUrl:       'https://novo-portal.redacaonota1000.com.br',
  legacyUrl:      'https://www.redacaonota1000.com.br',
  cmApiUrl:       'https://cm-services.redacaonota1000.com.br',
  apiBaseUrl:     'https://services-portal.redacaonota1000.com.br',
  apiUrl:         'https://services-portal.redacaonota1000.com.br/api/v2',
  apiUrlv3:       'https://services-portal.redacaonota1000.com.br/api/v3',
  healthUrl:      'https://services.redacaonota1000.com.br/actuator/health',
  cookieDomain:   '.redacaonota1000.com.br',
  gtmContainerId: 'GTM-KSFX65KS',
  // plurallFeedbackId: 1019, — re-add when PlurallTracker is re-enabled
};
